export default "/images/Epocrates.png?5dc02fe6a60dbeab3b0036a04fad15b7";